import { useState, useEffect, useRef } from "react";
import css from "../Form.module.css";
import "./MultiSelectDropDown.css";

const MultiSelectDropdown = ({ children, onChange }) => {
  const { label, name, options = [], value = [], toggleOption, disabled} = children;

  const [selected, setSelected] = useState(value || []);
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    setSelected(value);
  }, [value]);

  const isAllSelected = selected.length === options.length;

  const handleToggle = (checked) => {
    const updated = checked ? options.map((o) => o.id) : [];
    setSelected(updated);
    children.value = updated;
    onChange && onChange();
  };

  const handleSelect = (id) => {
    setSelected((prevSelected) => {
      const isSelected = prevSelected.includes(id);
      const updated = isSelected
        ? prevSelected.filter((item) => item !== id)
        : [...prevSelected, id];
      
      children.value = updated;
      onChange && onChange();
      return updated;
    });
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const getSelectedLabels = () => {
    return options.filter(opt => selected.includes(opt.id)).map(opt => opt.label);
  };

  return (
    <div className="FormControl" ref={dropdownRef}>
      {label && (
        <div>
          <label htmlFor={name}>{label}</label>
        </div>
      )}

      <div style={{ position: "relative" }}>
        <button type="button" className="dropdown-button" onClick={() => setOpen(!open)} disabled={disabled}>
          {selected.length > 0 ? (
            <div className="selected-tags">
              {getSelectedLabels().map((tagLabel) => (
                <span key={tagLabel} className="tag">
                  {tagLabel}
                </span>
              ))}
            </div>
          ) : (
            <span className="placeholder-text">Select roles</span>
          )}
          <svg
            className={`dropdown-arrow ${open ? "open" : ""}`}
            width="16"
            height="16"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M5 7L10 12L15 7"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>

        {open && (
          <div className="dropdown-menu">
            {options.map((opt) => (
              <label key={opt.id} className="checkbox-item">
                <input
                  type="checkbox"
                  checked={selected.includes(opt.id)}
                  onChange={() => handleSelect(opt.id)}
                  disabled={disabled}
                />
                <span className="checkbox-label">{opt.label}</span>
              </label>
            ))}
          </div>
        )}
      </div>

      {toggleOption && (
        <div className="togggle-switch-container">
          <label className="togggle-switch">
            <input
              type="checkbox"
              checked={isAllSelected}
              onChange={(e) => handleToggle(e.target.checked)}
            />
            <span className="sliderr"></span>
          </label>
          <span className="toggle-label">{toggleOption.label}</span>
        </div>
      )}
    </div>
  );
};

export default MultiSelectDropdown;